module.exports = __webpack_public_path__ + "img/icon6.d8daf006.jpg";